import { CompanySettings, CompanySettingsDef, Favicon } from "@mcleod/core";

export interface LMECompanySettingsDef extends CompanySettingsDef {
    //auth
    company_icon: string;
    default_move_type: string;
    carrier_scorecard_licensed: boolean;
    late_route_enabled: boolean;
    mobile_comm_licensed_active: boolean;
    show_movement_type: boolean;
}

export class LMECompanySettings extends CompanySettings {
    public static getSingleton(): LMECompanySettings {
        return CompanySettings.getSingleton() as LMECompanySettings;
    }

    public static get(): LMECompanySettingsDef {
        return LMECompanySettings.getSingleton().values as LMECompanySettingsDef;
    }

    public override get values(): LMECompanySettingsDef {
        return super.values as LMECompanySettingsDef;
    }

    protected getValuesInternal(): LMECompanySettingsDef {
        return this._values as LMECompanySettingsDef;
    }

    override _doAfterSet(newValues: LMECompanySettingsDef, isAuthSet?: boolean) {
        super._doAfterSet(newValues, isAuthSet);
        Favicon.setOrDefault(this.getValuesInternal()?.company_icon);
    }
}
